import React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PersonalPlanChart from "../../../components/PersonalPlanChart";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { getMonthYearInFuture } from "../../../utils/date";
import { nextPageRoute } from "../../../utils/modules";

const imagesToPreload = ["/loading/star.svg"];

const PersonalPlan = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <MobileViewLayout>
      <div className="flex-grow-1 px-4">
        <h1 className="fw-bold text-center fs30" style={{ marginTop: "73px" }}>
          <Trans i18nKey={"personal_plan.title"} components={{ tag: <br /> }} />
        </h1>
        <p
          className="fw-semibold text-center fs18"
          style={{ margin: "10px 0px" }}
        >
          <Trans i18nKey={"personal_plan.based_on_answers"} />
        </p>
        <div className="w-100">
          <p
            className="fw-bold text-center fs18"
            style={{ margin: "10px 0px" }}
          >
            <Trans
              i18nKey={"personal_plan.confident_freelancer_by"}
              values={getMonthYearInFuture(2)}
            />
          </p>
          <div
            className="d-flex justify-content-center align-items-center "
            style={{
              border: "2px solid #F2F2F2",
              padding: "10px 5px",
              borderRadius: "10px",
            }}
          >
            <PersonalPlanChart barValues={[20, 53, 75, 97]} />
          </div>
        </div>
        <div className="sticky-button">
          <Button
            onClick={() =>
              nextPageRoute(
                navigate,
                `/${params.gender}/planloading`,
                dispatch,
                imagesToPreload
              )
            }
            className="w-100 main-button py-3 fw-bold text-white mt-4 mb-1 bgSecondary "
            style={{ height: "60px", border: "0px solid" }}
          >
            <Trans i18nKey={"common_text.continue"} />
          </Button>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default PersonalPlan;
